import React from 'react';
import { useGlobalContext } from '@honeycomb/data';
import { useBreakpoints, Styler, Button2, ControlIcon, Dialog, ModalContent, ModalFooter, ModalHeader, Sidebar, TypographyBody, Skeleton2, Notification2, Avatar, } from '@honeycomb/ui-core';
import { interjectResourceString } from '../../utils/interjectResourceString';
import { pluraliseCount } from '../../utils/pluraliseCount';
import { useAppliedFiltersCount } from './useAppliedFiltersCount';
export function FiltersModal({ children, loading, filteredDataCount = 0, product, }) {
    const { resourceStrings: { SRP_FILTERBUTTON_LABEL, MODAL_FILTER_RESULTS_TITLE, NORESULTS_MATCHING_FILTERS_MAIN, NORESULTS_MATCHING_FILTERS_FLIGHTS_SUB, FILTERS_DIALOG_BUTTON_LABEL, FILTERS_DIALOG_BUTTON_LABEL_SINGLUAR, FILTERS_DIALOG_BUTTON_LABEL_LOADING, }, } = useGlobalContext();
    const [open, setOpen] = React.useState(false);
    const { mediumUp } = useBreakpoints();
    const scrollRef = React.useRef(null);
    const modalContentScroll = React.useRef(0);
    const appliedFiltersCount = useAppliedFiltersCount(product);
    const onFilterPanelScroll = () => {
        var _a;
        if ((_a = scrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollTop) {
            modalContentScroll.current = scrollRef.current.scrollTop;
        }
    };
    const getButtonLabel = () => {
        if (loading) {
            return FILTERS_DIALOG_BUTTON_LABEL_LOADING;
        }
        return pluraliseCount(filteredDataCount, {
            singular: FILTERS_DIALOG_BUTTON_LABEL_SINGLUAR,
            plural: interjectResourceString(FILTERS_DIALOG_BUTTON_LABEL, filteredDataCount),
        });
    };
    const modalContent = [
        React.createElement(ModalHeader, { closeButton: true }, MODAL_FILTER_RESULTS_TITLE),
        React.createElement(ModalContent, { ref: scrollRef, onScroll: onFilterPanelScroll, bg: "background.offset" },
            React.createElement(Styler, { py: 4 },
                !loading && filteredDataCount === 0 && (React.createElement(Notification2, { color: "info", variant: "compact", mb: 5 },
                    React.createElement(TypographyBody, { weight: "bold", "data-id": "no-results-text" }, NORESULTS_MATCHING_FILTERS_MAIN),
                    React.createElement("p", { "data-id": "no-results-sub-text" }, NORESULTS_MATCHING_FILTERS_FLIGHTS_SUB))),
                children)),
        React.createElement(ModalFooter, null,
            React.createElement(Button2, { "data-id": "view-matches", color: "callToAction", size: "l", fullWidth: true, disabled: !filteredDataCount, onClick: () => setOpen(false), loading: loading }, getButtonLabel())),
    ];
    return (React.createElement(React.Fragment, null,
        loading ? (React.createElement(Skeleton2, { radius: 10 },
            React.createElement(Button2, { w: 120 }, SRP_FILTERBUTTON_LABEL))) : (React.createElement(Button2, { "data-id": "filter", onClick: () => setOpen(true), color: "primary", icon: React.createElement(ControlIcon, null), decoration: appliedFiltersCount ? (React.createElement(Avatar, { color: "common.white", textColor: "primary.base" }, appliedFiltersCount)) : undefined, pr: appliedFiltersCount > 0 ? 3 : undefined }, SRP_FILTERBUTTON_LABEL)),
        !mediumUp ? (React.createElement(Dialog, { open: open, onClose: () => setOpen(false), fullScreen: true }, modalContent)) : (
        // Sidebar for larger devices
        React.createElement(Sidebar, { open: open, width: "xl", onClose: () => setOpen(false), side: "start" }, modalContent))));
}
